module.exports = __webpack_public_path__ + "static/media/YF18_0.4319bf21.jpg";